export { ContactCardDetails } from './ContactCardDetails'
